




















/* Created- 19 - Aug - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaCardDialog from "../Common/Container/ParticaDialogCard.vue";
import { IssueStorageDTO, IssueTrackingLogModel } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
@Component(
	{
		name: "IssueTrackingLog",
		components: { ParticaCardDialog }
	})
export default class IssueTrackingLog extends Vue {
	@Prop() private data: IssueTrackingLogModel[]; // your data   
	private search: string = "";
	private showstats: boolean = false;
	private headers: any[] = [
		{ text: "Time", value: "time", sortable: true },
		{ text: "Message", value: "message", sortable: true },
	];
	private getFormat(date: Date) {
		return date.toISOString();
	}
}



